import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { Checkbox } from '../../../components/Checkbox';
import { EditSquare } from '../../../components/Icon';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { IbanField } from './IbanField';
import { DoubleVATModal } from './DoubleVATModal';
import { updateCompanyProperties } from '../actions';
import { selectConfig } from '../../Api/selectors';
import {
  COMPANY_DETAILS_FINANCIAL_INFO_CARD,
  COMPANY_CURRENCY_OPTIONS,
  COMPANY_VINDAT_PAYMENTTYPE,
  COMPANY_VINDAT_PAYMENTCONDITION,
  BTW_COUNTRIES,
} from '../constants';
import { AppClientId } from '../../Shared/constants';
import { VAT_DUPLICATE_MESSAGE } from '../../../utils/request';
import env from '../../../env';
import styles from './CardFinancialInfo.module.css';
import cn from 'classnames';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';

const Container = styled.div`
  font-size: 14px;

  .card-header {
    margin-bottom: 20px;
  }
  .card-title {
    white-space: nowrap;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-edit-square {
    color: #d9d9d9;
  }

  .row-input {
    .col-1 {
      flex-basis: 25%;
    }
    .col-2 {
      flex-basis: 57%;
    }
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }

  .dropdown-BTW {
    > .Dropdown-root {
      min-width: 50px;
      max-width: 50px;

      > .Dropdown-menu {
        min-width: 130px;
      }
    }
  }
`;

const InputCardWrapper = styled.div`
  .input-card-wrapper {
    > .decorated {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: 8px;
    }
  }
`;

const DROPDOWN_OPTIONS = {
  company_from_eu: ['NL', 'EU', 'OUTSIDE_EU'],
  currency: COMPANY_CURRENCY_OPTIONS,
  vindat_paymenttype: COMPANY_VINDAT_PAYMENTTYPE,
  vindat_paymentcondition: COMPANY_VINDAT_PAYMENTCONDITION,
};

const STATE = {
  isEditCompany: false,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyFinanceCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    COMPANY_DETAILS_FINANCIAL_INFO_CARD.map(property => {
      if (this.props.company[property]) {
        this.setState({ [property]: this.props.company[property] });
      }
    });
  }

  get isSkipVATCheking() {
    let skip = false;

    if (this.props.company.BTW_number === this.state['BTW_number']) {
      skip = true;
    }
    return skip;
  }

  get btwNumberInputValue() {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.state?.BTW_number?.includes(o.value));
    if (isWithCode) {
      return this.state?.BTW_number?.substring(2) || '';
    }
    return this.state?.BTW_number;
  }

  dropdown(type) {
    const vals = DROPDOWN_OPTIONS[type];

    let options = vals.map(val => ({
      label: this.lbl(`company.property.${type}.${val}`),
      value: val,
    }));
    if (type == 'currency') {
      options = vals.map(currency => ({
        label: currency.value,
        value: currency.value,
      }));
    }

    const value = options.find(o => o.value == this.state[type]);

    return (
      <div className={styles.container}>
        <Dropdown
          controlClassName={'dropdown-card'}
          options={options}
          value={value}
          onChange={pair => this.setState({ [type]: pair.value })}
          className={styles.dropdown}
        />
      </div>
    );
  }

  btwDropdown(property) {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    let value = options.find(o => this.state[property]?.includes(o.value));

    return (
      <div className={styles.container}>
        <Dropdown
          options={options}
          value={value?.value ? value?.value + ' ' : ''}
          className={styles.dropdown}
          onChange={pair => {
            if (value?.value) {
              this.setState({ BTW_number: `${pair.value}${this.state?.BTW_number?.substring(2) || ''}` });
              return;
            }
            return this.setState({ BTW_number: `${pair.value}${this.state?.BTW_number || ''}` });
          }}
        />
      </div>
    );
  }

  onBtwNumberChange(evt, property) {
    {
      let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
      const isWithCode = options.find(o => this.state[property]?.includes(o.value));

      if (isWithCode?.value) {
        this.setState({ [property]: `${isWithCode?.value}${evt.target.value}` });
        return;
      }

      this.setState({ [property]: evt.target.value });
    }
  }

  input(type) {
    return (
      <input
        className="form-control"
        value={this.state[type]}
        onChange={evt => this.setState({ [type]: evt.target.value })}
      />
    );
  }

  checkbox(type, label) {
    return (
      <CheckboxComponent
        label={label}
        onChange={() => {
          if (!this.state.isEditCompany) return;
          const value = this.state[type] === '1' ? '0' : '1';

          this.setState({ [type]: value });
        }}
        checked={this.state[type] == '1'}
      />
    );
  }

  isShowPropertyCell(type) {
    if (this.state.isEditCompany) {
      return true;
    }
    if (this.props.company[type] && !this.state.isEditCompany) {
      return true;
    }
    return false;
  }

  edit(options) {
    let prop = {
      properties: [],
      addresses: [],
      accountManagerId: this.props.company?.accountManagerId || null,
    };

    COMPANY_DETAILS_FINANCIAL_INFO_CARD.map(type => {
      if (this.state[type] && type == 'BTW_number') {
        return prop.properties.push({
          name: type,
          value: this.state[type].replace(/\s/g, '')?.toUpperCase(),
        });
      }
      if (this.state[type] && type != 'billing_address') {
        prop.properties.push({
          name: type,
          value: this.state[type],
        });
      }
    });

    this.props.patch(
      prop.properties,
      this.props.company?.addresses,
      prop.accountManagerId,
      result => {
        if (result?.data?.message?.toLowerCase() === VAT_DUPLICATE_MESSAGE?.toLowerCase()) {
          this.setState({
            showDoubleVATModal: true,
            matchedCompaniesIds: result?.data?.matchedCompaniesIds,
          });
          return;
        }
        this.reset();
      },
      true,
    );
  }

  onCancelDoubleVATModal() {
    this.setState({
      showDoubleVATModal: false,
      matchedCompaniesIds: [],
    });
  }

  resetProps() {
    COMPANY_DETAILS_FINANCIAL_INFO_CARD.map(property => {
      if (this.props.company[property]) {
        this.setState({ [property]: this.props.company[property], isEditCompany: false });
      }
    });
  }

  rows(company) {
    return COMPANY_DETAILS_FINANCIAL_INFO_CARD;
  }

  reset() {
    this.setState({ ...STATE });
  }

  renderCard(company) {
    return (
      <Card className="company-info-card info-card data">
        <Container>
          <h2>{this.lbl('company.info.data.financial_details')}</h2>
          <List>{this.rows().map(row => this.renderRow(row, company))}</List>
        </Container>
      </Card>
    );
  }

  render() {
    const company = this.props.company;
    const address = company.addresses.find(a => a.type?.name === 'invoice');

    return (
      <Card className="company-info-card info-card data">
        {this.state.showDoubleVATModal && this.state.matchedCompaniesIds?.[0] && (
          <DoubleVATModal
            onSave={() => this.save({ skipVatUniquenessCheck: true })}
            onCancel={this.onCancelDoubleVATModal.bind(this)}
            existsCompanyId={this.state.matchedCompaniesIds[0]}
          />
        )}
        <Container>
          <HBox className={styles.header}>
            <h2 className="card-title">{this.lbl('company.info.data.financial_details')}</h2>

            <div
              className="icon-block"
              onClick={() => {
                this.setState(prevState => ({
                  isEditCompany: !prevState.isEditCompany,
                }));
              }}
            >
              {!this.props.noEdit && <EditSquare className={styles.iconEditSquare} />}
            </div>
          </HBox>
          <>
            {this.rows().map(property => {
              if (property == 'billing_address' && address?.addressLine1 != null) {
                return (
                  address && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          <div className={styles.labelTable}>
                            <strong className={styles.label}>
                              {!address ? '' : address.addressLine1 + ' ' + address.postcode + ' ' + address.city}
                            </strong>
                          </div>
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {!address ? '' : address.addressLine1 + ' ' + address.postcode + ' ' + address.city}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'IBAN') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    {this.state.isEditCompany ? (
                      <>
                        <label className={cn('form-label', styles.label)}>{this.lbl(`company.property.${property}`)}</label>
                        <InputCardWrapper>
                          <div className="input-card-wrapper">
                            <IbanField
                              cardWidth={{ maxWidth: '100%' }}
                              small
                              company={company}
                              value={this.state[property]}
                              type="IBAN"
                            />
                          </div>
                        </InputCardWrapper>
                      </>
                    ) : (
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    )}
                  </div>
                );
              }

              // if (property == 'IBAN') {
              //   return (
              //     <div className={styles.containerLabel} key={property}>
              //       {this.state.isEditCompany ? (
              //         <>
              //           <label className={cn('form-label', styles.label)}>{this.lbl(`company.property.${property}`)}</label>
              //           <div className={styles.formField}>
              //           <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
              //           <div className={styles.labelTable}>{company[property]}</div>
              //         </div>
              //         </>
              //       ) : (
              //         <div className={styles.formField}>
              //           <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
              //           <div className={styles.labelTable}>{company[property]}</div>
              //         </div>
              //       )}
              //     </div>
              //   );
              // }

              if (property == 'IBAN_approved') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    <CheckboxComponent
                      checked={this.state[property] == '1'}
                      label={this.lbl(`company.property.${property}`)}
                    />
                  </div>
                );
              }

              if (property == 'IBAN_approved') {
                return (
                  <Row key={property}>
                    <Cell>{this.lbl(`company.property.${property}`)}</Cell>
                    <Cell>
                      <Checkbox checked={this.state[property] == '1'} />
                    </Cell>
                  </Row>
                );
              }

              if (property == 'IBAN_approved_manual') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    <CheckboxComponent
                      checked={this.state[property] == '1'}
                      label={this.lbl(`company.property.${property}`)}
                    />
                  </div>
                );
              }

              if (property == 'BTW_number') {
                return (
                  company[property] && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.btwDropdown(property)}

                          <div className="mt-2">
                            <input
                              className="form-control"
                              value={this.btwNumberInputValue}
                              onChange={evt => this.onBtwNumberChange(evt, property)}
                            />
                          </div>
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'currency') {
                return (
                  this.isShowPropertyCell && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'customernumber') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.relation_number`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.relation_number`)}</div>
                          <div className={styles.labelTable}>
                            {this.lbl(`company.property.${property}.${company[property]}`)}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              // if (property == 'vindat_paymenttype') {
              //   return (
              //     this.isShowPropertyCell && (
              //       <Row key={property}>
              //         <Cell>{this.lbl(`company.property.${property}`)}</Cell>
              //         {this.state.isEditCompany ? this.dropdown(property) : <Cell>{company[property]}</Cell>}
              //       </Row>
              //     )
              //   );
              // }

              if (property == 'vindat_paymentcondition') {
                return (
                  this.isShowPropertyCell && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'no_incoming_payment_before_transport') {
                if (env.clientId !== AppClientId.INDEWAL) return;
                return (
                  <div className={styles.containerLabel} key={property}>
                    <CheckboxComponent
                      checked={this.state[property] == '1'}
                      label={this.lbl(`company.property.${property}`)}
                    />
                  </div>
                );
              }

              if (property == 'wait_for_pickup') {
                if (env.clientId !== AppClientId.INDEWAL) return;
                return (
                  <div className={styles.containerLabel} key={property}>
                    <CheckboxComponent
                      checked={this.state[property] == '1'}
                      label={this.lbl(`company.property.${property}`)}
                    />
                  </div>
                );
              }

              if (property == 'no_release_before_incoming_transport') {
                if (env.clientId !== AppClientId.INDEWAL) return;
                return (
                  <div className={styles.containerLabel} key={property}>
                    <CheckboxComponent
                      checked={this.state[property] == '1'}
                      label={this.lbl(`company.property.${property}`)}
                    />
                  </div>
                );
              }

              if (property == 'company_from_eu') {
                return (
                  this.isShowPropertyCell && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'finance_type') {
                return (
                  company[property] && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          <h5>{company[property]}</h5>
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'status') {
                return (
                  company[property] && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          <div className={styles.labelTable}>
                            <strong className={styles.label}>
                              {company[property] ? this.lbl(`company.property.status.${company[property]}`) : ''}
                            </strong>
                          </div>
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {company[property] ? this.lbl(`company.property.status.${company[property]}`) : ''}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }
              if (property == 'bordercross') {
                return (
                  company[property] && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          <h5>{company[property] ? this.lbl(`company.property.status.${company[property]}`) : ''}</h5>
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {company[property] ? this.lbl(`company.property.status.${company[property]}`) : ''}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }
              return (
                this.isShowPropertyCell(property) && (
                  <div className={styles.containerLabel} key={property}>
                    {this.state.isEditCompany ? (
                      <>
                        <label className={cn('form-label', styles.label)}>{this.lbl(`company.property.${property}`)}</label>
                        {this.input(property)}
                      </>
                    ) : (
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {this.lbl(`company.property.${property}.${company[property]}`)}
                        </div>
                      </div>
                    )}
                  </div>
                )
              );
            })}
          </>
          <div>
            {this.state.isEditCompany && (
              <div className="d-flex gap-2 mt-2">
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.resetProps.bind(this)}>
                  {this.lbl('cancel')}
                </ButtonComponent>
                &nbsp; &nbsp;
                <ButtonComponent style={'ButtonSoftEdit'} onClick={this.edit.bind(this)}>
                  {this.lbl('save')}
                </ButtonComponent>
              </div>
            )}
          </div>
        </Container>
      </Card>
    );
  }
}

CompanyFinanceCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    patch(props, addresses, accountManagerId, callback, skipVatUniquenessCheck) {
      dispatch(
        updateCompanyProperties(ownProps.company?.id, props, addresses, accountManagerId, callback, skipVatUniquenessCheck),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyFinanceDataCard = compose(withConnect, withRouter)(CompanyFinanceCardComp);
